import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useDocumentTitle } from '../../../App/hooks'

const FixedHeaderWithScrolledArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-x: auto;
`

const FixedHeader = styled.div`
  position: relative;
  z-index: 1;
`

const StyledMainWrap = styled.main`
  display: flex;
  flex: 1;
  overflow: auto;
`

const MainWrap = ({ children, className, pageTitle, fixedHeader }) => {
  useDocumentTitle(pageTitle)

  return (
    <FixedHeaderWithScrolledArea>
      {fixedHeader && (
        <FixedHeader data-test='fixed-header'>{fixedHeader}</FixedHeader>
      )}
      <StyledMainWrap className={className}>
        {children}
      </StyledMainWrap>
    </FixedHeaderWithScrolledArea>
  )
}

MainWrap.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string,
  fixedHeader: PropTypes.node,
}

export default MainWrap
